document.addEventListener('DOMContentLoaded', function() {
  console.log('Script loaded and event listener attached');

  // Add a 500ms delay before executing the logic
  setTimeout(function() {
    document.querySelectorAll('.bundly__product_option').forEach((container) => {
      const nestedDivs = container.querySelectorAll('div'); // Find nested divs inside `.bundly__product_option`

      // Traverse up to find the nearest ancestor with the class `bundly__component`
      const parentComponent = container.closest('.bundly__component');

      // Determine the class to add based on the count of nested divs
      const className = nestedDivs.length > 1 ? 'multiple-divs' : 'single-or-none';

      // Add the class to both `bundly__product_option` and its parent `bundly__component`
      container.classList.add(className);

      if (parentComponent) {
        parentComponent.classList.add(className);
        console.log(
          `Added "${className}" class to both bundly__product_option and its parent bundly__component`
        );
      } else {
        console.warn('No bundly__component parent found for:', container);
      }
    });
  }, 750); // 500ms delay before execution
});
